"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getTwoDecimals(number) {
    return ("" + number).padStart(2, "0");
}
exports.getTwoDecimals = getTwoDecimals;
function transformDateToServer(date) {
    if (!date) {
        return null;
    }
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    return "" + date.getFullYear() + "-" + getTwoDecimals(date.getMonth() + 1) + "-" + getTwoDecimals("" + date.getDate());
}
exports.transformDateToServer = transformDateToServer;
function transformDateArrayToServer(dateArray) {
    return dateArray.map(function (date) { return transformDateToServer(date); });
}
exports.transformDateArrayToServer = transformDateArrayToServer;
function transformDateArrayFromServer(candidate) {
    if (!candidate) {
        return [];
    }
    if (candidate.split) {
        candidate = JSON.parse(candidate);
    }
    return candidate.map(transformDateFromServer);
}
exports.transformDateArrayFromServer = transformDateArrayFromServer;
function transformDateFromServer(candidate) {
    return candidate ? new Date(candidate) : null;
}
exports.transformDateFromServer = transformDateFromServer;
function transformTimestampToServer(date) {
    if (!date) {
        return null;
    }
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    ;
    return "" + date.getFullYear() + "-" + getTwoDecimals(date.getMonth() + 1) + "-" + getTwoDecimals("" + date.getDate()) + " " + getTwoDecimals(date.getHours()) + ":" + getTwoDecimals(date.getMinutes());
}
exports.transformTimestampToServer = transformTimestampToServer;
function transformTimestampArrayToServer(timestampArray) {
    return timestampArray.map(transformTimestampToServer);
}
exports.transformTimestampArrayToServer = transformTimestampArrayToServer;
//# sourceMappingURL=utils.js.map